import * as BsIcons from "react-icons/bs";
import * as CgIcons from "react-icons/cg";

const GetIcon = ({ icon, size, color }) => {
  const Icons = {
    ...BsIcons,
    ...CgIcons,
  };

  const Icon = Icons[icon];

  if (!Icon) {
    return null;
  }

  return <Icon size={size} color={color} />;
};

export default GetIcon;
